export const StirType = {
  Stir: {
    value: 'StirType',
    describe: 'Stir',
    image: 'Stir.svg',
  },

  StirSrc: [
    {
      name: 'Stir',
      value: 'Stir.svg',
    },
    {
      name: 'StirPress',
      value: 'StirPress.svg',
    },
    {
      name: 'StirTank',
      value: 'StirTank.svg',
    },
  ],
}
